import { ClassProvider, Injectable, inject } from '@angular/core';

import { I18NEXT_SERVICE } from 'angular-i18next';

import { VALIDATION_MESSAGES, ValidationMessages, ValidatorProps } from '@hdms/shared/util-core';

@Injectable()
export class ValidationTranslations implements ValidationMessages {
  private readonly i18NextService = inject(I18NEXT_SERVICE);

  get(key: string, context: string, props: ValidatorProps, ns: string = null): string {
    const options = { context, defaultValue: null, ns, ...props };
    return this.i18NextService.t(`validation.${key}`, options);
  }
}

export const VALIDATION_MESSAGES_PROVIDER: ClassProvider = {
  provide: VALIDATION_MESSAGES,
  useClass: ValidationTranslations
};
